Core.ReservationsRouter = Core.SubRouter.extend({
    routes: {

        '': 'reservations',

        'new': 'newReservation',
        ':id': 'viewReservation',
        ':id/edit': 'editReservation',
        ':id/copy': 'copyReservation',

        'mine': 'mine',
        'all': 'all',
        'templates': 'templates',
        'customer/:id': 'customer',
        'asset/:id': 'asset',
        '*': 'reservations'
    },

    reservations: function () {
        debug.log('reservations');
        var view = new ReservationListView({scrolling: true});
        view.fetchList('all');
        view.render();
        view.selected = Core.param('select');
        app.setMainView(view, 'reservations', { wideContainer: true});
    },

    newReservation: function () {
        debug.log('new reservation');
        var view = new ReservationDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = true;
        view.loading = false;
        view.fillInDefaults();
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'reservations');
        view.resetAvailability();
    },

    viewReservation: function (id) {
        debug.log('view reservation', id);
        var view = new ReservationDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = false;
        if (!view.model || view.model.id != id)
            view.setModel(new Reservation({id: id}));
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'reservations');
    },

    editReservation: function (id) {
        debug.log('edit reservation', id);
        var view = new ReservationDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = true;
        if (!view.model || view.model.id != id)
            view.setModel(new Reservation({id: id}));
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'reservations');
    },

    copyReservation: function (id) {
        debug.log('copy reservation', id);
        var view = new ReservationDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = true;
        var template = new Reservation();
        template.set(JSON.parse(sessionStorage['core_reservation_template']));
        var model = new Reservation();
        model.setFromTemplate(template);
        if (template.get('title'))
            model.set('title', template.get('title'));
        view.selectedTemplate = template;
        view.modelIsCopy = true;
        view.setModel(model);
        app.setMainView(view, 'reservations');
    },

    mine: function () {
        debug.log('my reservations');
        var view = new ReservationListView({scrolling: true});
        view.selectList('mine');
        app.setMainView(view, 'reservations', { wideContainer: true});
    },

    all: function () {
        debug.log('all reservations');
        var view = new ReservationListView({scrolling: true});
        view.selectList('all');
        app.setMainView(view, 'reservations', { wideContainer: true});
    },

    templates: function () {
        debug.log('templates');
        var view = new ReservationListView({scrolling: true});
        view.fetchList('templates');
        app.setMainView(view, 'reservations', { wideContainer: true});
    },

    customer: function (id) {
        debug.log('customer reservation', id);
        var view = new ReservationListView({scrolling: true});
        view.selectList('customer-'+id);
        app.setMainView(view, 'reservations', { wideContainer: true});
    },

    asset: function (id) {
        debug.log('asset reservation', id);
        var view = new ReservationListView({scrolling: true});
        view.selectList('asset-'+id);
        app.setMainView(view, 'reservations', { wideContainer: true});
    }

});
